var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"},on:{"click":function($event){return _vm._initializeChart()}}},[_c('v-skeleton-loader',{staticClass:"skeleton-justify",attrs:{"type":"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }